// extracted by mini-css-extract-plugin
module.exports = {"header":"Confirmation__header--JMOUe","wrapper":"Confirmation__wrapper--2KEG5","takeover":"Confirmation__takeover--3TMcU"};